<template>
  <div>
    <!-- footer -->
    <footer class="footer">
      <div class="w980 clearfix">
        <div class="footer_left">
          <div>
            <router-link to="/home">主页</router-link>
            <router-link to="/team">关于</router-link>
            <router-link to="/project">项目</router-link>
            <router-link to="/customer">客户</router-link>
            <router-link to="/certification">资质</router-link>
            <router-link to="/news">最新消息</router-link>
            <router-link to="/contact">联络我们</router-link>
          </div>

          <p>
            &copy; 2020 深圳市同为装饰设计工程有限公司 版权所有
            <a href="https://beian.miit.gov.cn" target="_blank"
              >粤ICP备14055597号</a
            >
          </p>
        </div>
        <dl class="footer_right">
          <dt>关于我们</dt>
          <dd>
            <a href="#" class="iconfont icon-Facebook"></a>
            <a href="#" class="iconfont icon-xinlang"></a>
            <a href="#" class="iconfont icon-in"></a>
          </dd>
        </dl>
      </div>

      <!-- 返回顶部 -->
      <p class="backTop" v-if="isShowimg" @click="backtop">
        <i class="iconfont icon-icon-xia"></i>
      </p>
    </footer>

    <!-- footer_mobile -->
    <footer class="footer_mobile">
      <dl>
        <dt>关于我们</dt>
        <dd>
          <a href="#" class="iconfont icon-Facebook"></a>
          <a href="#" class="iconfont icon-xinlang"></a>
          <a href="#" class="iconfont icon-in"></a>
        </dd>
        <dd>&copy; 2020 深圳市同为装饰设计工程有限公司 版权所有</dd>
        <dd>
          <a
            href="https://beian.miit.gov.cn"
            target="_blank"
            style="font-size: 14px; color: #000;"
            >粤ICP备14055597号</a
          >
        </dd>
      </dl>
      <!-- 返回顶部 -->
      <p class="backTop" v-if="isShowimg" @click="backtop">
        <i class="iconfont icon-icon-xia"></i>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowimg: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;

      if (scrollTop > 500) {
        this.isShowimg = true;
      } else {
        this.isShowimg = false;
      }
    },

    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 10);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/components/footer.scss";
</style>
